import axios from '../../utils/axios';

export const getTeams = async (partnerId) => {
  const response = await axios.get(
    `/partners/${partnerId}/teams`
  );
  return response.data;
};
